import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';

import { settingsSelectors, State, UserRole } from '@wam/shared';
import { authenticationSelectors } from '@wam/authentication';
import { isInternalAdminOrAccountAdminOrSupportEngineer } from '../authentication/user.data';

@Injectable({
  providedIn: 'root',
})
export class InternalAdminOrAccountAdminOrSupportEngineerOrEnrollmentSupportGuard {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.store.pipe(select(authenticationSelectors.getUserRoles)),
    ]).pipe(
      map(
        ([userType, userRoles]) =>
          isInternalAdminOrAccountAdminOrSupportEngineer(userType, userRoles) ||
          userRoles.includes(UserRole.ENROLLMENT_SUPPORT),
      ),
      tap((isInternalAdminOrAccountAdmin: boolean) => {
        if (!isInternalAdminOrAccountAdmin) {
          this.router.navigate(['/']);
        }
      }),
      take(1),
    );
  }

  canLoad(): Observable<boolean> {
    return this.canActivate();
  }
}
